// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"163":"docs","177":"home","647":"referral","655":"swap","777":"multi_swap","784":"stats"}[chunkId] + "." + {"163":"0ae660b3","177":"f2857043","647":"61c21113","655":"ab0fe636","777":"306cd118","784":"7c280664"}[chunkId] + ".css";
};